import { Plus, ArrowUpRight, Star } from "lucide-react";
import { Link } from "react-router-dom";
import { useCurrency } from "@/lib/currency";

export const ProductCard = ({ product, onAdd }) => {
  const img = product.primary_image || (product.images && product.images[0]);
  const summary = product.review_summary || { count: 0, avg: 5.0 };
  const { formatPrice } = useCurrency();
  const pdpPath = `/product/${product.slug || product.id}`;
  return (
    <div
      className="group border-r border-b border-neutral-200 bg-white flex flex-col"
      data-testid={`product-card-${product.id}`}
    >
      <Link
        to={pdpPath}
        className="relative aspect-square overflow-hidden bg-neutral-50 block"
        data-testid={`product-link-${product.id}`}
      >
        <img
          src={img}
          alt={product.name}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
          decoding="async"
          onError={(e) => {
            e.currentTarget.src =
              "https://images.pexels.com/photos/5922101/pexels-photo-5922101.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=900&h=900&fit=crop";
          }}
        />
        <div className="absolute top-3 left-3 text-[10px] tracking-[0.2em] uppercase bg-white px-2 py-1 font-medium">
          In stock
        </div>
      </Link>
      <div className="p-5 flex-1 flex flex-col justify-between gap-3">
        <Link to={pdpPath} className="block">
          <h3 className="font-heading text-base font-bold leading-snug text-black line-clamp-2 min-h-[2.8rem] hover:underline underline-offset-4">
            {product.name}
          </h3>
        </Link>
        {summary.count > 0 && (
          <div className="flex items-center gap-1.5 text-xs" data-testid={`rating-${product.id}`}>
            <div className="flex items-center gap-0.5 text-black">
              {[1, 2, 3, 4, 5].map((i) => (
                <Star key={i} className={`w-3 h-3 ${i <= Math.round(summary.avg) ? "fill-current" : "text-neutral-300"}`} />
              ))}
            </div>
            <span className="font-bold">{summary.avg.toFixed(1)}</span>
            <span className="text-neutral-500">({summary.count})</span>
          </div>
        )}
        <div className="flex items-end justify-between gap-3">
          <div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-neutral-400 font-medium">
              Wholesale
            </div>
            <div className="font-heading text-2xl font-black tracking-tight">
              {formatPrice(product.price)}
            </div>
          </div>
          <div className="flex gap-1">
            <button
              onClick={() => onAdd && onAdd(product)}
              className="flex items-center justify-center w-9 h-9 bg-black text-white hover:bg-neutral-800 transition-colors"
              data-testid={`add-to-cart-${product.id}`}
              aria-label="Add to cart"
            >
              <Plus className="w-4 h-4" />
            </button>
            <Link
              to={pdpPath}
              className="flex items-center justify-center w-9 h-9 border border-neutral-300 hover:border-black hover:bg-neutral-50 transition-colors"
              data-testid={`view-more-${product.id}`}
              aria-label="View more"
            >
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
